// extracted by mini-css-extract-plugin
export default {"main":"Feedback_main__GIdzk"};